import { apiRequest } from "./apiClient";

const DURATION_MS = {
  "30m": 30 * 60 * 1000,
  "1h": 60 * 60 * 1000,
  "2h": 2 * 60 * 60 * 1000,
};

export const buildFamilyStatusPayload = ({ statusKey, duration = "1h", now = new Date() }) => {
  const updatedAt = new Date(now).toISOString();
  const durationMs = DURATION_MS[duration] || null;
  return {
    key: statusKey,
    updatedAt,
    expiresAt: durationMs ? new Date(new Date(now).getTime() + durationMs).toISOString() : null,
  };
};

export async function aileDurumuGuncelle({ familyId, userUid, statusKey, duration }) {
  if (!familyId || !userUid || !statusKey) throw new Error("Aile durumu bilgileri eksik.");
  const fallbackFamilyStatus = buildFamilyStatusPayload({ statusKey, duration });
  const data = await apiRequest(`/families/${encodeURIComponent(familyId)}/members/${encodeURIComponent(userUid)}`, {
    method: "PATCH",
    body: JSON.stringify({ familyStatus: { key: statusKey, duration: duration || "1h" } }),
  });
  const familyStatus = data?.familyStatus || fallbackFamilyStatus;
  return {
    ...familyStatus,
    familyStatus,
    statusChanged: data?.statusChanged !== false,
    durationChanged: data?.durationChanged === true,
    unchanged: data?.unchanged === true,
    shouldNotify: data?.shouldNotify !== false,
    cleared: false,
  };
}

export async function aileDurumuKapat({ familyId, userUid }) {
  if (!familyId || !userUid) throw new Error("Aile durumu bilgileri eksik.");
  const data = await apiRequest(`/families/${encodeURIComponent(familyId)}/members/${encodeURIComponent(userUid)}`, {
    method: "PATCH",
    body: JSON.stringify({ familyStatus: { clear: true } }),
  });
  return {
    familyStatus: null,
    statusChanged: data?.statusChanged === true,
    durationChanged: false,
    unchanged: data?.unchanged === true,
    shouldNotify: false,
    cleared: data?.cleared !== false,
  };
}
